import { ReactNode, isValidElement } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

type ProductsGridProps = {
    products: ReactNode[];
    title: ReactNode;
    isMobile?: boolean;
};

export const BaseGrid = ({ products, title, isMobile }: ProductsGridProps) => {
    return (
        <div
            css={css({
                [media.only.sm]: {
                    maxWidth: "328px"
                }
            })}
        >
            {isValidElement(title) ? (
                title
            ) : (
                <div
                    css={css({
                        "color": "#101214",
                        "font-size": "14px",
                        "font-family":
                            "'Charlie Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif",
                        "line-height": "20px"
                    })}
                >
                    {title}
                </div>
            )}

            <div
                css={css({
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                    columnGap: token("space.400")
                })}
                data-testid="product-grid"
            >
                {products}
            </div>
        </div>
    );
};
